/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface CentreData
 */
export interface CentreData {
    /**
     * 
     * @type {string}
     * @memberof CentreData
     */
    centreName?: string;
    /**
     * 
     * @type {number}
     * @memberof CentreData
     */
    orderAmount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CentreData
     */
    turnover?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CentreData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof CentreData
     */
    pno?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CentreData
     */
    averageOrderPrice?: MoneyOutput;
}

/**
 * Check if a given object implements the CentreData interface.
 */
export function instanceOfCentreData(value: object): value is CentreData {
    return true;
}

export function CentreDataFromJSON(json: any): CentreData {
    return CentreDataFromJSONTyped(json, false);
}

export function CentreDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CentreData {
    if (json == null) {
        return json;
    }
    return {
        
        'centreName': json['centreName'] == null ? undefined : json['centreName'],
        'orderAmount': json['orderAmount'] == null ? undefined : json['orderAmount'],
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'pno': json['pno'] == null ? undefined : json['pno'],
        'averageOrderPrice': json['averageOrderPrice'] == null ? undefined : MoneyOutputFromJSON(json['averageOrderPrice']),
    };
}

export function CentreDataToJSON(json: any): CentreData {
    return CentreDataToJSONTyped(json, false);
}

export function CentreDataToJSONTyped(value?: CentreData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'centreName': value['centreName'],
        'orderAmount': value['orderAmount'],
        'turnover': MoneyOutputToJSON(value['turnover']),
        'spend': MoneyOutputToJSON(value['spend']),
        'pno': value['pno'],
        'averageOrderPrice': MoneyOutputToJSON(value['averageOrderPrice']),
    };
}

